(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-collection-filters]');
    if (!root) return;

    const overlay = root.querySelector('[data-collection-filters-overlay]');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        root.classList.add('collection-filters--open');
      });
      document.documentElement.style.overflow = 'hidden';
      const toggle = document.querySelector('[data-collection-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      const closeBtn = root.querySelector('[data-collection-filters-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.classList.remove('collection-filters--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      const toggle = document.querySelector('[data-collection-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 300);
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-collection-filter-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }

      if (!root.classList.contains('collection-filters--open')) return;

      const closeTrigger = e.target.closest('[data-collection-filters-close]');
      if (closeTrigger) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target === overlay) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('collection-filters--open')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-filters"] && !Shopify.designMode) return;
  try {
    (function () {
    const root = document.querySelector('[data-search-filters]');
    if (!root) return;

    const overlay = root.querySelector('[data-search-filters-overlay]');
    let lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      requestAnimationFrame(function () {
        root.classList.add('collection-filters--open');
      });
      document.documentElement.style.overflow = 'hidden';
      const toggle = document.querySelector('[data-search-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      const closeBtn = root.querySelector('[data-search-filters-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      root.classList.remove('collection-filters--open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      const toggle = document.querySelector('[data-search-filter-open]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        root.hidden = true;
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      }, 300);
    }

    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-search-filter-open]');
      if (trigger) {
        e.preventDefault();
        open();
        return;
      }

      if (!root.classList.contains('collection-filters--open')) return;

      const closeTrigger = e.target.closest('[data-search-filters-close]');
      if (closeTrigger) {
        e.preventDefault();
        close();
        return;
      }

      if (e.target === overlay) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('collection-filters--open')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
